import { useSelector, useDispatch } from "react-redux";

import { fillOrder } from '../store/interactions';

import sort from '../assets/sort.svg'

import { orderBookSelector } from "../store/selectors";

const OrderBook = () => {
    const dispatch = useDispatch()

    const provider = useSelector(state => state.provider.connection)
    const exchange = useSelector(state => state.exchange.contract)
    const symbols = useSelector(state => state.tokens.symbols)
    const orderBook = useSelector(orderBookSelector)

    const fillOrderHandler = (order) => {
        fillOrder(provider, exchange, order, dispatch)
    }

    return (
      <div className="component exchange__orderbook">
        <div className='component__header flex-between'>
          <h2 className="h22">Order Book:</h2>
        </div>
  
        <div className="flex">

        {!orderBook || orderBook.sellOrders.length === 0 ? (
            <p className="flex-center">No Sell Orders</p>
        ) : (
            <table className='exchange__orderbook--sell'>
                <caption className="title">&gt; <span>Selling</span></caption>
                <thead>
                <tr>
                    <th>{symbols && symbols[0]}<img src={sort} alt='Sort'/></th>
                    <th>{symbols && symbols[0]}/{symbols && symbols[1]}<img src={sort} alt='Sort'/></th>
                    <th>{symbols && symbols[1]}<img src={sort} alt='Sort'/></th>
                </tr>
                </thead>
                <tbody>

                {/* mapping sell orders */}

                {orderBook && orderBook.sellOrders.map((order, index) => {
                    return(
                        <tr key={index} onClick={() => fillOrderHandler(order)}>
                            <td>{order.token0Amount}</td>
                            <td style={{color: `${order.orderTypeClass}`}}>{order.tokenPrice}</td>
                            <td>{order.token1Amount}</td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        )}
  
          <div className='divider'></div>
  
        {!orderBook || orderBook.buyOrders.length === 0 ? (
                <p className="flex-center">No Buy Orders</p>
            ) : (
                <table className='exchange__orderbook--buy'>
                    <caption className="title">&gt; <span>Buying</span></caption>
                    <thead>
                    <tr>
                        <th>{symbols && symbols[0]}<img src={sort} alt='Sort'/></th>
                        <th>{symbols && symbols[0]}/{symbols && symbols[1]}<img src={sort} alt='Sort'/></th>
                        <th>{symbols && symbols[1]}<img src={sort} alt='Sort'/></th>
                    </tr>
                    </thead>
                    <tbody>

                    {/* mapping buy orders */}

                    {orderBook && orderBook.buyOrders.map((order, index) => {
                        return(
                            <tr key={index} onClick={() => fillOrderHandler(order)}>
                                <td>{order.token0Amount}</td>
                                <td style={{color: `${order.orderTypeClass}`}}>{order.tokenPrice}</td>
                                <td>{order.token1Amount}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            )}
        </div>
      </div>
    );
}
  
export default OrderBook;
